// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-skip-link":"sapcnqr-skip-link-623554"};